import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

import Layout from "../../../layout";

import validate from "./form-validate";

const ContatoCadastrar = () => {
  const location = useLocation();
  const history = useHistory();

  const [stateTiposProjetos, setStateTipoProjetos] = useState([]);

  const [state, setState] = useState({
    id: 0,
    tipo_projeto_id: "",
    titulo: "",
    descricao: "",
    titulo_in: "",
    descricao_in: "",
    titulo_es: "",
    descricao_es: "",
    imagem: "",
    url: "",
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-projeto").valid()) {
      return;
    }

    try {
      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/projeto", state);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      history.push("/projeto");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar o projeto.");
    }
  };

  const buscarDados = async (url) => {
    const requisicao = await api.get(`${url}`);

    const { data } = requisicao;

    if (!data.status) {
      danger(data.mensagem);
      return;
    }

    if (!data.data) {
      return;
    }

    return data.data;
  };

  const carregarTiposProjetos = async () => {
    return await buscarDados("/tipo-projeto");
  };

  const carregarDados = async () => {
    if (!location.state) {
      return;
    }

    return await buscarDados(`/projeto/${location.state.id}`);
  };

  useEffect(() => {
    const carregarTodosDados = async () => {
      try {
        showLoading(".ibox-content");

        const [tipos, projeto] = await Promise.all([
          carregarTiposProjetos(),
          carregarDados(),
        ]);

        setStateTipoProjetos(tipos);

        if (projeto) {
          setState(projeto);
        }

        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados do projeto");
      }
    };

    let validacao = window.$("#form-projeto").validate(validate);

    carregarTodosDados();

    return () => validacao.destroy();
  }, [location.state]);

  return (
    <>
      <Layout
        titulo="Ibraflex - Projetos"
        header="Cadastro do Projeto"
        action={{ titulo: "Voltar", link: "/projeto" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Dados do projeto</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                <div className="row">
                  <div className="col-lg-12">
                    <form id="form-projeto">
                      <div className="row">
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Selecione um tipo de projeto</label>
                            <select
                              className="form-control"
                              id="tipo_projeto_id"
                              name="tipo_projeto_id"
                              value={state.tipo_projeto_id}
                              onChange={(e) => preencherValoresEdits(e)}
                            >
                              <option key="-1" value="">
                                Selecione um tipo de projeto
                              </option>

                              {stateTiposProjetos
                                .sort((a, b) => (a.nome > b.nome ? 1 : -1))
                                .map((tipo) => (
                                  <option key={tipo.id} value={tipo.id}>
                                    {tipo.nome}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Imagem do projeto</label>
                            <input
                              type="text"
                              placeholder="Imagem do projeto"
                              className="form-control"
                              name="imagem"
                              value={state.imagem}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <label>Url do vídeo do projeto</label>
                            <input
                              type="text"
                              placeholder="Url do vídeo do projeto"
                              className="form-control"
                              name="url"
                              value={state.url}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <div class="tabs-container">
                              <ul class="nav nav-tabs" role="tablist">
                                <li>
                                  <a
                                    class="nav-link active"
                                    data-toggle="tab"
                                    href="#tab-1"
                                  >
                                    Português
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="nav-link"
                                    data-toggle="tab"
                                    href="#tab-2"
                                  >
                                    Inglês
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="nav-link"
                                    data-toggle="tab"
                                    href="#tab-3"
                                  >
                                    Espanhol
                                  </a>
                                </li>
                              </ul>
                              <div class="tab-content">
                                <div
                                  role="tabpanel"
                                  id="tab-1"
                                  class="tab-pane active"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Título do projeto</label>
                                          <input
                                            type="text"
                                            placeholder="Título do projeto"
                                            className="form-control"
                                            name="titulo"
                                            value={state.titulo}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Descrição do projeto</label>
                                          <textarea
                                            className="form-control"
                                            id="descricao"
                                            name="descricao"
                                            placeholder="Descrição do projeto"
                                            rows="5"
                                            value={state.descricao}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  role="tabpanel"
                                  id="tab-2"
                                  class="tab-pane"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Título do projeto</label>
                                          <input
                                            type="text"
                                            placeholder="Título do projeto"
                                            className="form-control"
                                            name="titulo_in"
                                            value={state.titulo_in}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Descrição do projeto</label>
                                          <textarea
                                            className="form-control"
                                            id="descricao_in"
                                            name="descricao_in"
                                            placeholder="Descrição do projeto"
                                            rows="5"
                                            value={state.descricao_in}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  role="tabpanel"
                                  id="tab-3"
                                  class="tab-pane"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Título do projeto</label>
                                          <input
                                            type="text"
                                            placeholder="Título do projeto"
                                            className="form-control"
                                            name="titulo_es"
                                            value={state.titulo_es}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Descrição do projeto</label>
                                          <textarea
                                            className="form-control"
                                            id="descricao_es"
                                            name="descricao_es"
                                            placeholder="Descrição do projeto"
                                            rows="5"
                                            value={state.descricao_es}
                                            onChange={(e) =>
                                              preencherValoresEdits(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-success float-right m-t-n-xs"
                          type="submit"
                          onClick={(e) => enviarFormulario(e)}
                        >
                          <strong>Salvar</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default ContatoCadastrar;
